import type { AppStore } from "@/store/AppStore";
import type { CreateNoteInput, CreateNoteOutput } from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  createNoteInputSchema,
  createNoteOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";
import { buildNoteContentForCreate } from "@/modules/ai-toolkit/tools/notes/note-mutation-tools.helpers";
import { EventContext } from "@/domains/metrics/context";
import { uuidModule } from "@/modules/uuid";

export const createNote = async ({
  store,
  input,
}: {
  store: AppStore;
  input: CreateNoteInput;
}): Promise<CreateNoteOutput> => {
  const noteId = uuidModule.generate();

  await store.notes.createNote({
    noteId,
    eventContext: EventContext.SidePanelSmartActions,
    noteContent: buildNoteContentForCreate({
      title: input.title,
      bodyMdx: input.bodyMdx,
    }),
  });

  if (input.openAfterCreate) {
    store.navigation.goToNote({
      noteId,
      openInSameTab: true,
    });
  }

  return {
    created: true,
    noteId,
  };
};

export const createNoteTool: AiToolkitToolDefinition<
  AiToolkitToolName.CreateNote,
  CreateNoteInput,
  CreateNoteOutput
> = {
  name: AiToolkitToolName.CreateNote,
  inputSchema: createNoteInputSchema,
  outputSchema: createNoteOutputSchema,
  strict: true,
  execute: createNote,
};
